// removed by extract-text-webpack-plugin
module.exports = {"footerContain":"_1k6GFczvUF58hLCLMSVG6-","creditText":"_338P1aSuEgdAGSBfb5fVan","portfolioLink":"_38aITXSIl3N-LepFBmureQ"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/Footer.css
// module id = 407
// module chunks = 0